module.exports = __webpack_public_path__ + "static/media/UserManualDE.5dac2ce1.pdf";